module.exports = __webpack_public_path__ + "image/editor-handle.ef96ef29.png";